<template>
  <div class="auth-page-container">
    <div class="ambient-glow ambient-glow--indigo"></div>
    <div class="ambient-glow ambient-glow--emerald"></div>

    <v-row align="center" justify="center" class="fill-height ma-0 auth-content-row">
      <v-col cols="12" sm="11" md="9" lg="7" xl="6">
        <v-card class="glass-card pa-6 pa-sm-8 auth-card" elevation="0">
          <div class="text-center mb-8">
            <div class="auth-brand-badge mb-3">
              <v-icon size="32" color="primary">mdi-account-plus</v-icon>
            </div>
            <h1 class="text-h4 font-weight-bold mb-2">Create Media Catalog Account</h1>
            <p class="text-body-2 text-medium-emphasis">
              Join Media Catalog to organize and catalog your personal multimedia collection
            </p>
          </div>

          <register-form @register-success="onRegisterSuccess" />

          <v-divider class="my-6" />

          <div class="text-center">
            <v-btn
              to="/login"
              variant="text"
              class="btn-modern"
              prepend-icon="mdi-login"
            >
              Already have an account? Sign In
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="4000"
      color="success"
      location="top"
      rounded="lg"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-check-circle</v-icon>
        {{ snackbar.text }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import RegisterForm from '@/components/RegisterForm.vue'

export default {
  name: 'Register',
  components: {
    RegisterForm,
  },
  setup() {
    const router = useRouter()
    const snackbar = ref({
      show: false,
      text: '',
    })

    const onRegisterSuccess = () => {
      snackbar.value = {
        show: true,
        text: 'An activation email has been sent to your email address. Please check your inbox.',
      }
      setTimeout(() => {
        router.push('/')
      }, 4000)
    }

    return {
      onRegisterSuccess,
      snackbar,
    }
  },
}
</script>

<style scoped>
.auth-page-container {
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 32px 16px;
}

.auth-content-row {
  position: relative;
  z-index: 2;
  width: 100%;
}

.auth-card {
  border-radius: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25) !important;
}

.auth-brand-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.25);
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.2);
}

.ambient-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  pointer-events: none;
  opacity: 0.25;
}

.ambient-glow--indigo {
  width: 450px;
  height: 450px;
  top: 5%;
  left: 10%;
  background: #6366f1;
}

.ambient-glow--emerald {
  width: 400px;
  height: 400px;
  bottom: 5%;
  right: 10%;
  background: #10b981;
}
</style>